// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getClinicById } from "../api";
import { ClinicType } from "../types";

type UseClinicByIdType = {
  useToken: boolean;
  clinicId: string | undefined;
};

export const useClinicById = ({ useToken, clinicId }: UseClinicByIdType) => {
  const { getToken } = useTokenAccess();

  return useQuery<ClinicType>({
    queryKey: ["clinics", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();

      let token = null;
      if (useToken) token = await getToken();

      return getClinicById(token, clinicId);
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
